
<template>
  <div style="height:100%">
    <BannerPrincipal/>
    <Banner2/>
    <Banner3/>
    <Banner4/>
    <BannerIndicadores/>
    <Banner6/>
    <Banner7/>
    <Banner8/>
    <Banner9/>
    <Banner10/>
    <bannerFooter/>
  </div>
</template>

<script>

import BannerPrincipal from './componentes/BannerPrincipal'
import Banner2 from './componentes/Banner2'
import Banner3 from './componentes/Banner3'
import Banner4 from './componentes/Banner4'
import BannerIndicadores from './componentes/BannerIndicadores'
import Banner6 from './componentes/Banner6'
import Banner7 from './componentes/Banner7'
import Banner8 from './componentes/Banner8'
import Banner9 from './componentes/Banner9'
import Banner10 from './componentes/Banner10'
import bannerFooter from '../components/BannerFooter'

export default {
  name: "LandingPage",
  components: {
    BannerPrincipal,
    Banner2,
    Banner3,
    Banner4,
    BannerIndicadores,
    Banner6,
    Banner7,
    Banner8,
    Banner9,
    Banner10,
    bannerFooter
  },
  beforeMount() {},
};
</script>

<style scope>
</style>